import React, { memo, useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, Progress } from "reactstrap";
import {
    AI_RISK_LEVEL_COLOR,
    sortAiRiskDistributionItems,
} from "../ai-risk-chart-constants";
import "./style.scss";

const RiskLevels = memo(({ t, riskLevels = [], isFetching }) => {
    const rows = useMemo(() => {
        const sorted = sortAiRiskDistributionItems(riskLevels);
        return sorted.map((row) => {
            const percent = Math.round(Number(row.percent) || 0);
            return {
                level: row.level,
                title: row.title,
                percent,
                color: AI_RISK_LEVEL_COLOR[row.level] || "#90A4AE",
            };
        });
    }, [riskLevels]);

    if (isFetching) {
        return (
            <div className="dt-field dt-skeleton mb-3" style={{ width: "100%", height: "460px" }} />
        );
    }

    return (
        <Card
            className="mb-3 card_box_Shadow flex-grow-1 ai-governance-risk-levels"
            style={{ height: "460px" }}
        >
            <CardBody className="d-flex flex-column h-100" style={{ overflow: "hidden" }}>
                <h6 className="mb-3 fw-bold flex-shrink-0">{t("Risk Levels")}</h6>

                {!rows.length ? (
                    <p className="text-muted small mb-0">{t("There is no data")}</p>
                ) : (
                    <div className="flex-grow-1 overflow-auto pe-1">
                        {rows.map((row) => (
                            <div
                                key={row.level}
                                className="d-flex align-items-center gap-2 mb-3"
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 fw-semibold text-white"
                                    style={{
                                        width: 48,
                                        height: 48,
                                        backgroundColor: row.color,
                                        color: "#212529",
                                        fontSize: 13,
                                    }}
                                    title={t(row.title)}
                                >
                                    {row.percent}%
                                </div>

                                <Progress
                                    className="flex-grow-1 ai-governance-risk-levels__track"
                                    style={{
                                        height: 12,
                                        "--risk-level-color": row.color,
                                    }}
                                    value={row.percent}
                                    barClassName={
                                        row.percent > 0
                                            ? "ai-governance-risk-levels__bar"
                                            : "ai-governance-risk-levels__bar ai-governance-risk-levels__bar--empty"
                                    }
                                />
                            </div>
                        ))}
                    </div>
                )}
            </CardBody>
        </Card>
    );
});

export default withNamespaces()(RiskLevels);
